import { useState, useMemo } from "react";
import Modal from "../../../../components/Modals/Modal";
import SearchableSelect from "../../../../components/Common/SearchableSelect";
import {
    Page,
    Left,
    Right,
    HeaderRow,
    RoleListContainer,
    RoleItem,
    SearchInput,
} from "../styles/component.style";
import { BtnGeneral } from "../../../../styles/Buttons";
import { useHomologacion } from "../../../../hooks/useHomologacion";

function Accordion({ title, children, defaultOpen = true }) {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <div style={{ marginBottom: "6px", border: "1px solid #e2e8f0", borderRadius: "6px" }}>
            <button onClick={() => setOpen(!open)} style={{
                width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center",
                padding: "5px 10px", background: open ? "#f1f5f9" : "#f8fafc",
                border: "none", borderRadius: open ? "6px 6px 0 0" : "6px",
                cursor: "pointer", fontSize: "11px", fontWeight: "600", color: "#1e40af",
            }}>
                <span>{title}</span>
                <span style={{ fontSize: "10px", color: "#94a3b8" }}>{open ? "▲" : "▼"}</span>
            </button>
            {open && <div style={{ padding: "8px 10px", borderTop: "1px solid #e2e8f0" }}>{children}</div>}
        </div>
    );
}

function Field({ lbl, required, children }) {
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
            <label style={{ fontSize: "11px", color: "#64748b", fontWeight: "500" }}>
                {lbl}{required && <span style={{ color: "#ef4444", marginLeft: "2px" }}>*</span>}
            </label>
            {children}
        </div>
    );
}

const selectSx = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        borderRadius: "4px",
        fontSize: "11px",
        fontFamily: "var(--font-body)",
        backgroundColor: "#ffffff",
        minHeight: "26px",
        "& fieldset": { borderColor: "#cbd5e1" },
        "&:hover fieldset": { borderColor: "#94a3b8" },
        "&.Mui-focused fieldset": { borderColor: "#007bba" },
    },
    "& .MuiSelect-select": {
        padding: "3px 8px !important",
        fontSize: "11px",
        fontFamily: "var(--font-body)",
        display: "flex",
        alignItems: "center",
    },
};

export default function HomologacionValor() {
    const {
        filtered,
        search,
        setSearch,
        selectedId,
        selectedConsecutivo,
        form,
        setForm,
        loading,
        handleSelectGroup,
        handleSelectConfigItem,
        handleNew,
        saveValor,
        deleteValor,
        requestDeleteValor,
        confirmDeleteOpen,
        confirmDeleting,
        closeDeleteConfirm,
        consecutivos,
        getConsNombre,
        currentConsecutivoConfigs,
        consecutivoTipoFijado,
        TIPO_IGUAL,
        TIPO_RANGO,
    } = useHomologacion();

    const tipoBloqueado = false;

    const consecutivoOptions = useMemo(
        () =>
            consecutivos
                .slice()
                .sort((a, b) => Number(a.Consecutivo) - Number(b.Consecutivo))
                .map((c) => ({
                    value: String(c.Consecutivo),
                    label: `${c.Consecutivo} ${c.Api}`,
                })),
        [consecutivos]
    );

    const isRango = String(form.Tipo) === TIPO_RANGO;
    const isIgual = String(form.Tipo) === TIPO_IGUAL;

    return (
        <Page>
            <Left>
                <HeaderRow>
                    <h3 style={{ margin: 0, fontSize: "13px" }}>Homologación Valores</h3>
                    <BtnGeneral bg="cyan" padding="4px 8px" radius="5px" fw="600" fs="11px" onClick={handleNew}>
                        Nuevo
                    </BtnGeneral>
                </HeaderRow>

                <SearchInput
                    placeholder="Buscar por consecutivo o valor..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <RoleListContainer>
                    {loading && (
                        <p style={{ padding: "10px", color: "#94a3b8", fontSize: "12px" }}>Cargando...</p>
                    )}
                    {!loading && filtered.map((group) => (
                        <RoleItem
                            key={String(group.consecutivo)}
                            active={String(selectedConsecutivo) === String(group.consecutivo)}
                            onClick={() => handleSelectGroup(group)}
                        >
                            <div>
                                <strong style={{ fontSize: "12px" }}>{group.nombre}</strong>
                                <div style={{ fontSize: "10px", color: "#94a3b8", marginTop: "1px" }}>
                                    {group.consecutivo} · {group.count} registro{group.count !== 1 ? "s" : ""}
                                </div>
                            </div>
                        </RoleItem>
                    ))}
                    {!loading && filtered.length === 0 && (
                        <p style={{ padding: "10px", color: "#94a3b8", fontSize: "12px" }}>
                            No se encontraron registros
                        </p>
                    )}
                </RoleListContainer>
            </Left>

            <Right style={{ overflowY: "auto", padding: "8px 10px" }}>
                <HeaderRow style={{ marginBottom: "6px" }}>
                    <span style={{ fontSize: "11px", fontWeight: "600", color: "#334155" }}>
                        {form.id
                            ? `Editar: ${form.consecutivo} ${getConsNombre(form.consecutivo)}`
                            : form.consecutivo
                                ? `Nuevo: ${form.consecutivo} ${getConsNombre(form.consecutivo)}`
                                : "Nueva Homologación"}
                    </span>
                    <div style={{ display: "flex", gap: "6px" }}>
                        {form.id && (
                            <BtnGeneral bg="red" padding="4px 10px" radius="5px" fw="600" fs="11px" onClick={requestDeleteValor}>
                                Eliminar
                            </BtnGeneral>
                        )}
                        <BtnGeneral bg="green" padding="4px 16px" radius="5px" fw="600" fs="11px" onClick={saveValor}>
                            Guardar
                        </BtnGeneral>
                    </div>
                </HeaderRow>

                <Accordion title="Datos de Homologación">
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 16px" }}>
                        <Field lbl="ID:">
                            <input
                                readOnly
                                value={form.id || ""}
                                placeholder="(Asignado automáticamente)"
                                style={{ ...inp, background: "#f8fafc", color: "#94a3b8" }}
                            />
                        </Field>

                        <Field lbl="Consecutivo:" required>
                            <SearchableSelect
                                key={`consecutivo-${form.id || form.consecutivo || "new"}`}
                                value={form.consecutivo ? String(form.consecutivo) : ""}
                                onValueChange={(val) => setForm({ ...form, consecutivo: val || "" })}
                                options={consecutivoOptions}
                                placeholder="Buscar consecutivo..."
                                multiple={false}
                                searchable={true}
                                size="small"
                                sx={selectSx}
                            />
                        </Field>

                        <Field lbl="Tipo:" required>
                            <SearchableSelect
                                key={`tipo-${form.id || "tipo"}`}
                                value={String(form.Tipo || TIPO_IGUAL)}
                                disabled={tipoBloqueado}
                                onValueChange={(val) =>
                                    setForm({
                                        ...form,
                                        Tipo: val,
                                        ValorPosible: val === TIPO_RANGO ? "" : form.ValorPosible,
                                        RangoDesde: val === TIPO_IGUAL ? "" : form.RangoDesde,
                                        RangoHasta: val === TIPO_IGUAL ? "" : form.RangoHasta,
                                    })
                                }
                                options={[
                                    { value: TIPO_IGUAL, label: "1 - Igual" },
                                    { value: TIPO_RANGO, label: "2 - Rango" },
                                ]}
                                multiple={false}
                                searchable={false}
                                size="small"
                                sx={selectSx}
                            />
                        </Field>

                        <Field lbl="Valor Data:" required>
                            <input
                                value={form.ValorData}
                                onChange={(e) => setForm({ ...form, ValorData: e.target.value })}
                                style={inp}
                                placeholder="Ej: 1"
                            />
                        </Field>

                        {isIgual && (
                            <Field lbl="Valor Posible:" required>
                                <input
                                    value={form.ValorPosible}
                                    onChange={(e) => setForm({ ...form, ValorPosible: e.target.value })}
                                    style={inp}
                                    placeholder="Ej: POSITIVO"
                                />
                            </Field>
                        )}

                        {isRango && (
                            <>
                                <Field lbl="Rango Desde:" required>
                                    <input
                                        type="number"
                                        value={form.RangoDesde}
                                        onChange={(e) => setForm({ ...form, RangoDesde: e.target.value })}
                                        style={inp}
                                        placeholder="Ej: 0"
                                    />
                                </Field>
                                <Field lbl="Rango Hasta:" required>
                                    <input
                                        type="number"
                                        value={form.RangoHasta}
                                        onChange={(e) => setForm({ ...form, RangoHasta: e.target.value })}
                                        style={inp}
                                        placeholder="Ej: 80"
                                    />
                                </Field>
                            </>
                        )}
                    </div>
                </Accordion>

                <Accordion title={`Configuración actual del consecutivo ${form.consecutivo ? `(${form.consecutivo} ${getConsNombre(form.consecutivo)})` : ""}`} defaultOpen={!!form.consecutivo}>
                    {form.consecutivo ? (
                        currentConsecutivoConfigs.length === 0 ? (
                            <p style={{ fontSize: "11px", color: "#94a3b8", padding: "8px", margin: 0 }}>
                                No hay configuración guardada para este consecutivo.
                            </p>
                        ) : (
                            <div style={{
                                border: "1px solid #e2e8f0",
                                borderRadius: "5px",
                                overflow: "hidden",
                                fontSize: "11px",
                            }}>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <thead>
                                        <tr style={{ background: "#f1f5f9" }}>
                                            <th style={th}>#</th>
                                            <th style={th}>Tipo</th>
                                            <th style={th}>Valor Posible / Rango</th>
                                            <th style={th}>Valor Data</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentConsecutivoConfigs.map((it, idx) => {
                                            const tipoIt = String(it.Tipo || TIPO_IGUAL);
                                            const detalle =
                                                tipoIt === TIPO_RANGO
                                                    ? `${it.RangoDesde ?? ""} - ${it.RangoHasta ?? ""}`
                                                    : it.ValorPosible || "";
                                            return (
                                                <tr
                                                    key={it.id}
                                                    onClick={() => handleSelectConfigItem(it)}
                                                    style={{
                                                        cursor: "pointer",
                                                        background:
                                                            selectedId === it.id
                                                                ? "#e0f2fe"
                                                                : idx % 2 === 0
                                                                    ? "#ffffff"
                                                                    : "#f8fafc",
                                                    }}
                                                >
                                                    <td style={td}>{idx + 1}</td>
                                                    <td style={td}>
                                                        {tipoIt === TIPO_RANGO ? "Rango" : "Igual"}
                                                    </td>
                                                    <td style={td}>{detalle}</td>
                                                    <td style={td}>{it.ValorData}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        )
                    ) : (
                        <p style={{ fontSize: "11px", color: "#94a3b8", padding: "8px", margin: 0 }}>
                            Seleccione un consecutivo para ver su configuración.
                        </p>
                    )}
                </Accordion>
            </Right>

            <Modal
                isOpen={confirmDeleteOpen}
                onClose={confirmDeleting ? undefined : closeDeleteConfirm}
                title="Confirmar eliminación"
                width="420px"
                minH="200px"
                maxH="60vh"
                closeOnOverlay={false}
                closeOnEsc={!confirmDeleting}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "18px", fontFamily: "var(--font-body)" }}>
                    <p style={{ fontSize: "12px", color: "#334155", margin: 0, lineHeight: 1.5 }}>
                        ¿Deseas eliminar el registro del consecutivo <strong>{form.consecutivo || ""}</strong>?
                    </p>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                        <BtnGeneral
                            bg="gray"
                            padding="6px 14px"
                            radius="5px"
                            fw="600"
                            fs="12px"
                            onClick={closeDeleteConfirm}
                            disabled={confirmDeleting}
                        >
                            Cancelar
                        </BtnGeneral>
                        <BtnGeneral
                            bg="red"
                            padding="6px 14px"
                            radius="5px"
                            fw="600"
                            fs="12px"
                            onClick={deleteValor}
                            disabled={confirmDeleting}
                        >
                            {confirmDeleting ? "Eliminando..." : "Confirmar"}
                        </BtnGeneral>
                    </div>
                </div>
            </Modal>
        </Page>
    );
}

const inp = {
    flex: 1,
    padding: "3px 7px",
    borderRadius: "4px",
    border: "1px solid #cbd5e1",
    fontSize: "11px",
    boxSizing: "border-box",
    outline: "none",
    marginBottom: 0,
    width: "100%",
    background: "#ffffff",
    color: "#0f172a",
    fontFamily: "var(--font-body)",
};

const th = {
    padding: "4px 8px",
    textAlign: "left",
    fontSize: "10px",
    fontWeight: "600",
    color: "#475569",
    borderBottom: "1px solid #e2e8f0",
};

const td = {
    padding: "4px 8px",
    borderBottom: "1px solid #f1f5f9",
    color: "#0f172a",
    fontSize: "11px",
};
